import { createRef, memo, RefObject, VideoHTMLAttributes } from "react";
import { useVideo } from "./hooks";
import { Player } from "@/components/UI/Player";

interface IProps
  extends VideoHTMLAttributes<HTMLVideoElement> {
  videoRef?: RefObject<HTMLVideoElement | null>;
  onMounted?: () => void;
}

export const Video = memo(({
  src,
  videoRef = createRef<HTMLVideoElement>(),
  ...restProps
}: IProps) => {
  const { isHls } = useVideo({ src });

  return (
    <Player videoRef={videoRef} src={src} useHlsEngine={isHls} {...restProps} />
  );
});
